<template>
  <div class="container-custom" :style="styleObject">
    <header>
      <Header></Header>
    </header>
    <div class="content-custom">
      <div style="height: 100%">
        <div class="content" style="padding-bottom: 30px">
          <div class="i-search">
            <input
              v-model="searchKeyword"
              class="nosubmit"
              type="search"
              id="keyword_search"
              extraClass
              name="keyword_search"
              placeholder="Search for your branches"
              @input="getBranches"
            />
          </div>
          <div
            class="d-flex align-items-center mt-3 px-3"
            v-if="physicalBranch"
          >
            <div>
              <i class="material-icons-round opacity-10" style="font-size: 32px;">location_on</i>
            </div>
            <div class="ms-2 d-flex align-items-center font-weight-bold">
              {{ physicalBranch.name }}
            </div>
          </div>
          <div class="branch-list mt-1">
            <div
              v-for="branch in branches"
              :key="branch.id"
              class="branch-item"
            >
              <div class="branch-name me-3">{{ branch.branch_name }}</div>
              <button class="order-btn" @click="clickLink(branch.order_link)">
                Order Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="position-fixed top-1 end-1 message-success"
      style="z-index: 99999 !important"
    >
      <material-snackbar
        v-if="snackbarAsMember === 'danger' || snackbarAsMember === 'success'"
        title=""
        date=""
        :description="messageAsMember"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbarAsMember"
      />
    </div>
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Header from "../kiosk/components/Header.vue";
import OrderService from "@/services/order.service";

export default {
  name: "PhysicalBranchOrder",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    Header,
  },
  data() {
    return {
      snackbar: null,
      message: "",
      loaderActive: false,
      physicalBranch: "",
      branches: [],
      searchKeyword: "",
      searchTimerId: null,
      merchantCode: "",
      physicalBranchId: "",
    };
  },
  mounted() {
    this.merchantCode = this.$route.params.merchant_code;
    this.physicalBranchId = this.$route.params.physical_branch_id;

    if (this.merchantCode && this.physicalBranchId) {
      this.getBranches();
    }
  },
  computed: {
    styleObject() {
      return {
        "--color": this.$store.state.color,
      };
    },
  },
  methods: {
    onChangesearchKeyword(event) {
      this.searchKeyword = event.target.value;
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.getBranches();
      }, 1000);
    },

    getBranches() {
      this.showLoader();
      let dataForm = {
        search_keyword: this.searchKeyword,
        physical_branch_id: this.physicalBranchId,
      };

      OrderService.getBranches(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.physicalBranch = response.data.data.physical_branch;
            this.branches = response.data.data.branches;

            this.branches.forEach((branch) => {
              branch.order_link = new URL(
                `/${this.merchantCode}/${branch.branch_code}`,
                window.location.origin
              ).href;
            });
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
        }
      );
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    clickLink(link) {
      if (link && link != "") {
        this.showLoader();
        window.open(link, "_self");
      }
    },
  },
};
</script>

<style scoped>
.content {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25px;
  margin-top: 65px;
}

.i-search {
  padding-left: 24px !important;
  padding-right: 24px !important;
  background: var(--color);
  padding-bottom: 5px;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
  background-color: #ffffff !important;
  border-radius: 50px;
  text-align: left !important;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
  font-size: 13px;
}

input[type="search"]:focus {
  outline: none;
  border: none;
}

input.nosubmit {
  width: 100%;
  height: 32px;
  padding: 5px 4px 5px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
  margin-top: 5px;
}

.branch-list {
  padding: 0 1rem;
  font-size: 14px;
}

.branch-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #d3d3d3;
}

.branch-name {
  color: #222;
  font-weight: bold;
}

.order-btn {
  height: 40px;
  min-width: 120px;
  background-color: var(--color);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
